import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ShippingConfig {
  free_shipping_threshold: number;
  standard_shipping_cost: number;
  delivery_time_text: string;
  delivery_time_text_en?: string;
  enable_standard_delivery: boolean;
  enable_omniva_delivery: boolean;
  enable_salon_pickup: boolean;
}

const defaultConfig: ShippingConfig = {
  free_shipping_threshold: 30,
  standard_shipping_cost: 2.90,
  delivery_time_text: "Pristatymas per 2-3 darbo dienas",
  delivery_time_text_en: "Delivery in 2-3 business days",
  enable_standard_delivery: true,
  enable_omniva_delivery: true,
  enable_salon_pickup: true
};

export const useShippingSettings = () => {
  const [config, setConfig] = useState<ShippingConfig>(defaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadShippingSettings = async () => {
      try {
        console.log('Loading shipping settings from database...');
        const { data, error } = await supabase
          .from('settings')
          .select('value')
          .eq('key', 'shipping_config')
          .single();

        if (error && error.code !== 'PGRST116') {
          console.error('Error loading shipping settings:', error);
          return;
        }

        if (data?.value) {
          console.log('Loaded shipping config from database:', data.value);
          setConfig(data.value as any);
        } else {
          console.log('No shipping config found in database, using defaults:', defaultConfig);
        }
      } catch (error) {
        console.error('Error loading shipping settings:', error);
      } finally {
        setLoading(false);
      }
    };

    loadShippingSettings();
  }, []);

  return { config, loading };
};